/**
 * Scale Degree References
 *
 * Solfege names and functional descriptions for each scale degree.
 * Helps users understand how each note functions within a scale.
 */

export interface ScaleDegreeReference {
    degree: number;
    solfege: string;
    name: string;
    character: string;
    tendency: string;
}

export const scaleDegreeReferences: Record<number, ScaleDegreeReference> = {
    1: {
        degree: 1,
        solfege: "Do",
        name: "Tonic",
        character: "Home, stable, resolved",
        tendency: "Resting point"
    },
    2: {
        degree: 2,
        solfege: "Re",
        name: "Supertonic",
        character: "Stepping stone",
        tendency: "Moves to 1 or 3"
    },
    3: {
        degree: 3,
        solfege: "Mi",
        name: "Mediant",
        character: "Defines major/minor",
        tendency: "Relatively stable"
    },
    4: {
        degree: 4,
        solfege: "Fa",
        name: "Subdominant",
        character: "Gentle tension",
        tendency: "Pulls down to 3"
    },
    5: {
        degree: 5,
        solfege: "Sol",
        name: "Dominant",
        character: "Strong, stable",
        tendency: "Second home"
    },
    6: {
        degree: 6,
        solfege: "La",
        name: "Submediant",
        character: "Bittersweet",
        tendency: "Can go either way"
    },
    7: {
        degree: 7,
        solfege: "Ti",
        name: "Leading Tone",
        character: "Strong pull upward",
        tendency: "Wants to resolve to 1"
    }
};

// Helper to get reference by degree number
export const getScaleDegreeReference = (degree: number): ScaleDegreeReference | undefined => {
    return scaleDegreeReferences[degree];
};

// Helper to get all scale degree references as array
export const getAllScaleDegreeReferences = (): ScaleDegreeReference[] => {
    return Object.values(scaleDegreeReferences);
};
